let uiUrl = 'https://numedlabs.com';
let backendHost = 'https://numedlabs.com/product';
let authLoginUrl = 'https://numedlabs.com/auth/';
// let Apiurl="https://uatapi.numedlabs.com/";
let Apiurl="https://limsapi.numedlabs.com/";
const hostname = window && window.location && window.location.hostname;

// if (hostname === 'localhost') {
//   backendHost = 'http://localhost:8088';
//   authLoginUrl = 'http://localhost:3001/auth';
//   uiUrl = 'http://localhost:3000/'
//   Apiurl="http://localhost:59604/";
  
// }


export const backendUrl = backendHost;
export const loginUrl = authLoginUrl;

export const apiHost = backendHost+"/graphql";
export const assetHost = backendHost+"/assets";

export const baseUrl = uiUrl;

export const erpApiurl = Apiurl;


